import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';
import { ZIBUZZ_PUBLIC_KEY } from '../config/mappedEnv';


// Encrypt Data Transmission with Private & Public Key
export const Encrypt = (values) => {
  const jsonValues = JSON.stringify(values);

  // Step 1: Generate AES key (256 bits)
  const aesKey = CryptoJS.lib.WordArray.random(32); // AES key (256-bit)
  const aesIv = CryptoJS.lib.WordArray.random(16); // AES IV (128-bit)

  // Step 2: Encrypt the data with AES
  const data = CryptoJS.AES.encrypt(jsonValues, aesKey, { iv: aesIv }).toString();

  // Step 3: Encrypt the AES key using RSA (public key)
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(ZIBUZZ_PUBLIC_KEY);
  const aes_key = encryptor.encrypt(aesKey.toString(CryptoJS.enc.Base64));

  // Step 4: Return encrypted data and RSA-encrypted AES key
  return {
    data,
    aes_key,
    iv: aesIv.toString(CryptoJS.enc.Base64) // Return IV used for AES encryption
  };
};

/**
 * Use for every `axios.post(dbUserAndHub, …)` body. Same encryption as {@link Encrypt}.
 */
export const encryptUserAndHubPayload = (payload) => {
  return Encrypt(payload);
};


// Encrypt for Private Stores with Salt and IV
export const EncryptForStorage = (dataObject, passkey, options = {}) => {
  const normalizeWords = (value) => {
    if (!value) return null;
    if (typeof value === 'string') return CryptoJS.enc.Hex.parse(value);
    return value;
  };

  // 1. Generate or reuse salt
  const salt =
    normalizeWords(options.salt) || CryptoJS.lib.WordArray.random(128 / 8);

  // 2. Derive a 256-bit key from the passkey and salt
  // PBKDF2 makes it hard for hackers to guess the passkey via brute force
  const key = CryptoJS.PBKDF2(passkey, salt, {
    keySize: 256 / 32,
    iterations: 1000
  });

  const iv =
    normalizeWords(options.iv) || CryptoJS.lib.WordArray.random(128 / 8);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(dataObject), key, { iv: iv });

  return {
    encryptedBlob: encrypted.toString(),
    salt: salt.toString(),
    iv: iv.toString()
  };
};


// Decrypt Private Store data using the visitor's passkey
export const DecryptFromStorage = (encryptedBlob, passkey, salt, iv) => {
  try {
    // 1. Re-derive the same key using the same salt and parameters
    const saltWords = CryptoJS.enc.Hex.parse(salt);
    const ivWords = CryptoJS.enc.Hex.parse(iv);

    const key = CryptoJS.PBKDF2(passkey, saltWords, {
      keySize: 256 / 32,
      iterations: 1000
    });

    // 2. Decrypt the blob
    const decrypted = CryptoJS.AES.decrypt(encryptedBlob, key, { iv: ivWords });

    // 3. Convert to string and Parse back to JSON
    const plaintext = decrypted.toString(CryptoJS.enc.Utf8);

    if (!plaintext) throw new Error("Invalid Passkey");

    return JSON.parse(plaintext);
  } catch (error) {
    console.error("Decryption failed:", error.message);
    return null; // Return null so your UI can show "Incorrect Passkey"
  }
};
